export const AllowOnlyAlpha = (text) => {
  return text.replace(/[^a-zA-Z\s]/g, "");
};

export const AllowOnlyAlphaBrackets = (text) => {
  return text.replace(/[^a-zA-Z\s(){}]/g, "");
};
export const AllowOnlyNumeric = (text) => {
  return text.replace(/[^0-9]/g, "");
};

export const AllowOnlyNumericWithDash = (text) => {
  return text.replace(/[^0-9-]/g, "");
};

export const AllowOnlyAlphaNumeric = (text) => {
  return text.replace(/[^0-9a-zA-Z\s]/g, "");
};

export const IsValidEmailAddress = (text) => {
  let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.match(text);
};

export const formatNumber = (nums, isPhone) => {
  if (isPhone) {
    if (nums != null) return nums.replace(/(\d{4})(\d{7})/, "$1-$2");
    else return null;
  } else {
    if (nums != null) return nums.replace(/(\d{5})(\d{7})(\d{1})/, "$1-$2-$3");
    else return null;
  }
};
export const AllowOnlyAlphaNumericBrackets = (text) => {
  return text.replace(/[^0-9a-zA-Z\s(){}]/g, "");
};
export const removeFormatFromNumber = (nums) => {
  return nums.replace(/-/g, "");
};
export const AllowOnlyAlphaNumericWithDash = (text) => {
  return text.replace(/[^a-zA-Z0-9-]/g, "");
};
export const AllowOnlyDecimal = (text) => {
  return text.replace(/[^0-9.]/g, "");
};
export const AllowMessagesChar = (text) => {
  return text.replace(/[^0-9a-zA-Z\s-_'",.]/g, "");
};
export const AllowUsernameChar = (text) => {
  return text.replace(/[^0-9a-zA-Z\s_@]/g, "");
};
export const IsValidPassword = (pass) => {
  if (pass != undefined) {
    let _textCharCount = pass.length;
    let _digitCount = pass.replace(/[^0-9]/g, "").length;
    let _letterCountLowerCount = pass.replace(/[^a-z]/g, "").length;
    let _letterCountUpperCOunt = pass.replace(/[^A-Z]/g, "").length;
    let _letterSpecialCount = (pass.match(/[^a-zA-Z0-9]/g) || []).length;
    if (
      _textCharCount >= 8 &&
      _digitCount > 0 &&
      _letterCountLowerCount > 0 &&
      _letterCountUpperCOunt > 0 &&
      _letterSpecialCount > 0
    )
      return true;
    else return false;
  } else return true;
};
export const AllowOnlyCoordinates = (text) => {
  return text.replace(/[^0-9,. ]/g, "");
};
